module.exports = __webpack_public_path__ + "img/Tiu.4b72b5ac.png";